export default __webpack_public_path__ + "static/media/02.df0132cd.jpg";